"use client";

import { useState } from "react";
import { useCart } from "@/components/cart/CartProvider";
import { GiftNote } from "@/components/product/GiftNote";

export function BoxForm({ handle, available }: { handle: string; available: boolean }) {
  const { addBox, error } = useCart();
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState<"idle" | "adding" | "failed">("idle");

  const add = async () => {
    setStatus("adding");
    const ok = await addBox(handle, message.trim() || undefined);
    setStatus(ok ? "idle" : "failed");
    if (ok) setMessage("");
  };

  return (
    <div>
      {available ? <GiftNote value={message} onChange={setMessage} /> : null}
      <button
        type="button"
        className="btn btn-primary mt-7 w-full"
        onClick={add}
        disabled={!available || status === "adding"}
      >
        {!available ? "Sold out" : status === "adding" ? "Adding to cart" : "Add box to cart"}
      </button>
      {status === "failed" && error ? (
        <p role="alert" className="mt-3 text-[0.9375rem] text-gold">
          {error}
        </p>
      ) : null}
    </div>
  );
}
